import React from "react";

const PlaceholderCard = ({ count = 1, statsskelton, circle, ...rest }) => {
  return (
    <>
        {Array.from({ length: count }).map((_, index) => (
          <div className="group-user-card" key={index}>
            <div className="group-card w-100 px-3">
              <div className="group-avatar">
                <div
                  className="skeleton skeleton-avatar"
                  style={{ width: "5rem", height: "5rem", margin: ".2rem auto" }}
                />
              </div>
              <h6 className="group-name w-100 text-center">
                <div
                  className="skeleton skeleton-text"
                  style={{ width: "5rem", height: "1rem", margin: ".4rem auto" }}
                />
              </h6>
              <div className="group-details w-100 text-center" style={{ display: "block" }}>
                <div className="skeleton skeleton-text" style={{ width: "7rem", height: ".7rem", margin: "0 auto" }} />
              </div>
              {statsskelton && (
                <div className="stats w-100">
                  <span className="item d-block w-100">
                    <div
                      className="skeleton skeleton-text"
                      style={{ width: "5rem", height: "1rem", margin: "0 auto" }}
                    />
                  </span>
                </div>
              )}
            </div>
          </div>
        ))}
    </>
  );
};

export default PlaceholderCard;
